import { getCurrentOrg } from '.';
import type { CountryFilterMode } from '../components/CountryFilterDropdown';
import {
  ConversationApiService,
  ParticipantApiService,
} from '../services/conversation-participants';

import type {
  ConversationAudioFile,
  ConversationDto,
  MessageDto,
  ParticipantInfoDto,
  ConversationCostStatistics,
} from '../services/conversation-participants';

export type MessageResponse = MessageDto;
type ConversationResponseDTO = ConversationDto;
export type ConversationResponse = ConversationResponseDTO & {
  user_phone?: string;
  outbound_phone?: string;
  inbound_phone?: string;
};
export type ParticipantInfoResponse = ParticipantInfoDto;
export type ConversationAudioFileResponse = ConversationAudioFile;
export type GetConversationsFilters = {
  startedAt?: string;
  endedAt?: string;
  completedConversations?: boolean;
  conversationId?: string;
  userId?: string;
  userName?: string;
  agentId?: string;
  agentName?: string;
  agentTitle?: string;
  moreThan?: number;
  lessTnan?: number;
  conversationChannel?: ApiConversationChannel;
  mode?: CountryFilterMode;
  countries?: Array<string>;
  metricName?: string;
  metricValue?: string;
};

export type SelfCostStatistics = ConversationCostStatistics;

export type ApiConversationChannel =
  | 'mobile'
  | 'web'
  | 'phone_call'
  | 'whatsapp'
  | 'web-video'
  | 'web-audio'
  | 'mobile-video'
  | 'mobile-audio'
  | 'app';

export type ConversationsPayload = {
  xAiAgentOrganizationContext: string;
  botMasterId?: string;
  startedAt?: string;
  endedAt?: string;
  completedConversations?: boolean;
  conversationId?: string;
  userId?: string;
  userName?: string;
  agentId?: string;
  agentTitle?: string;
  agentName?: string;
  page?: number;
  size: number;
  sort?: Array<string>;
};

export const getConversationCountries = () => {
  return ConversationApiService.getConversationCountries(getCurrentOrg());
};

export const getConversation = (conversationId: string) => {
  return ConversationApiService.getConversation1(
    conversationId,
    getCurrentOrg()
  );
};
export const getConversationParticipantInfo = (externalId: string) => {
  return ParticipantApiService.getParticipantByExternalId1(
    externalId,
    getCurrentOrg()
  );
};
export const getConversationMessages = (
  conversationId: string,
  translationLanguage?: 'EN'
) => {
  return ConversationApiService.getMessagesByConversationId(
    getCurrentOrg(),
    conversationId,
    translationLanguage
  );
};
export const getConversationAudio = (conversationId: string) => {
  return ConversationApiService.getAudioFiles(conversationId, getCurrentOrg());
};
export const getConversationSelfCostStatistics = (conversationId: string) => {
  return ConversationApiService.getSelfCostStatistics(
    conversationId,
    getCurrentOrg()
  );
};

export const getConversations = (
  botMasterId: string,
  page: number,
  size: number,
  filters: GetConversationsFilters,
  sort?: SortState<string>
) => {
  const {
    userId,
    userName,
    endedAt,
    agentId,
    startedAt,
    agentName,
    agentTitle,
    conversationId,
    countries,
    mode,
    completedConversations,
    moreThan,
    lessTnan,
    conversationChannel,
    metricName,
    metricValue,
  } = filters;

  return ConversationApiService.getConversations(
    getCurrentOrg(),
    botMasterId,
    startedAt,
    endedAt,
    completedConversations,
    conversationId,
    userId,
    userName,
    agentId,
    agentTitle,
    agentName,
    mode,
    countries ? countries : [],
    conversationChannel,
    lessTnan,
    moreThan,
    page,
    size,
    sort?.name ? [`${sort.name},${sort.direction}`] : [],
    metricName,
    metricValue
  );
};
